<template>
    <div id="data-pip-view">
        <filter-view-sidebar :isSidebarActive="filterDataSidebar" @closeSidebar="toggleDataSidebar" @execFilter="filtrar" />
        <vx-card class="mt-4 overflow-hidden overlay-card">
            <label class="ml-2 text-sm font-bold opacity-100">Codigo Unico</label>
            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/4">
                    <vs-input class="w-full font-bold text-dark" v-model="inputSearchCui" v-validate="'required|numeric'" name="codigo" placeholder="Codigo Unico o SNIP"/>
                    <span class="text-sm text-danger" v-show="errors.has('codigo')">{{ errors.first('codigo') }}</span>
                </div>
                <div class="w-full mb-4 vx-col md:w-1/4">
                    <div class="flex-wrap items-center justify-end mb-2">
                        <vs-button @click="buscar" icon-pack="feather" icon="icon-search">Buscar</vs-button>
                    </div>           
                </div>
            </div>
            <div class="vx-row">
                <div class="w-full mb-4 vx-col md:w-1/2">
                    <label class="ml-2 text-sm font-bold opacity-100">Provincia</label>
                    <v-select :options="itemsProvincia" v-model="selectedProvincia" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="provincia">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-sm text-danger" v-show="errors.has('provincia')">{{ errors.first('provincia') }}</span>
                </div>
                <div class="w-full mb-4 vx-col md:w-1/2">
                    <label class="ml-2 text-sm font-bold opacity-100">Distrito</label>
                    <v-select :options="itemsDistrito" v-model="selectedDistrito" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="provincia">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-sm text-danger" v-show="errors.has('provincia')">{{ errors.first('provincia') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3">
                    <vs-table stripe ref="table" :data="itemsAll" pagination :max-items="itemsPerPage" class="mt-4" noDataText="No existen datos">
                        <template slot="thead">
                            <vs-th>CUI/COD. SNIP</vs-th>
                            <vs-th>COSTO DEL PROY.</vs-th>
                            <vs-th>AVANCE EJEC. (%)</vs-th>
                            <vs-th>AVANCE FIS. (%)</vs-th>
                            <vs-th></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].cui">
                                        <div @click="accessSsi(tr)" class="cursor-pointer">
                                            <vs-chip color="rgb(62, 101, 150)" transparent>
                                                <strong>
                                                    <span class="text-bold">{{data[indextr].cui}}</span>
                                                </strong>
                                            </vs-chip>
                                        </div>
                                    </vs-td>
                                    <vs-td :data="data[indextr].costo">
                                        <small class="font-medium text-dark"> {{ formatNumber(data[indextr].costo) }}</small>
                                    </vs-td>
                                    <vs-td :data="data[indextr].ajecucion">
                                        <small class="font-bold text-success text-bold"> {{ data[indextr].ajecucion }}</small>
                                    </vs-td>
                                    <vs-td :data="data[indextr].afisico">
                                        <small class="font-bold text-warning"> {{ data[indextr].afisico }}</small>
                                    </vs-td>
                                    <vs-td :data="data[indextr].meta" class="whitespace-no-wrap">
                                        <div class="vx-row-actions">
                                            <vx-tooltip text="Ver detalle" position="bottom">
                                                <vs-button @click="verDetalle(tr)" class="ml-2" color="rgb(62, 201, 214)" type="filled" icon-pack="feather" icon="icon-search" size="small"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                    <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                        <p class="text-sm truncate">
                            Mostrando registros del <strong>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}</strong> al <strong>{{ itemsAll.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsAll.length }}</strong> de un total de <strong>{{ itemsAll.length }}</strong> registros
                        </p>
                    </div>
                </div>
                <div class="w-full mt-4 vx-col md:w-2/3">
                    <div class="mb- map-holder">
                        <div id="map" class="w-full vx-col"></div>
                    </div>
                </div>
            </div>

            <div class="w-full vx-col">
                <div class="flex flex-col items-center justify-center text-white">
                    <h5 class="mt-4 text-primary"><strong>UNIDAD EJECUTORA: {{ unidad_ejecutora + ' - ' + nombre_ejecutora }}</strong></h5>
                </div>
            </div>

        </vx-card>

        <vs-popup id="modal-detalle-proyecto" title="Detalle del Proyecto" :active.sync="popupDetalleProyecto">
            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Código Único</label>
                    <div class="w-full mb-2 vx-col md:w-1/2">
                        <vs-input class="w-full font-bold text-dark" readonly v-model="inputCUI" v-validate="'required|numeric'" name="codigo" placeholder="Codigo único o SNIP"/>
                        <span class="text-sm text-danger" v-show="errors.has('codigo')">{{ errors.first('codigo') }}</span>
                    </div>
                </div>
            </div>

            <div class="w-full vx-col">
                <label class="ml-2 text-sm opacity-100">Nombre de la Inversión</label>
                <div class="w-full vx-col">
                    <vs-textarea class="w-full font-bold text-dark" readonly v-model="inputNombreInversion" v-validate="'required'" name="nombre" placeholder="Ingrese nombre de la Inversión"/>
                    <span class="text-sm text-danger" v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="ml-2 text-sm opacity-100">Modalidad de Ejecución</label>
                        <vs-input class="w-full font-bold text-dark" readonly v-model="inputModalidad" v-validate="''" name="modalidad" placeholder="Modalidad de ejecución"/>
                        <span class="text-sm text-danger" v-show="errors.has('modalidad')">{{ errors.first('modalidad') }}</span>
                    </div>
                </div>
            </div>

             <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="ml-2 text-sm opacity-100">PIM Vigente</label>
                        <vs-input class="w-full font-bold text-dark" readonly v-model="inputPimVigente" v-validate="''" name="pimvigente" placeholder=""/>
                        <span class="text-sm text-danger" v-show="errors.has('pimvigente')">{{ errors.first('pimvigente') }}</span>
                    </div>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="ml-2 text-sm opacity-100">Avance PIM(%)</label>
                        <vs-input class="w-full font-bold text-dark" readonly v-model="inputAvancePim" v-validate="''" name="avancepim" placeholder=""/>
                        <span class="text-sm text-danger" v-show="errors.has('avancepim')">{{ errors.first('avancepim') }}</span>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="ml-2 text-sm opacity-100">Avance Acumulado(%)</label>
                        <vs-input class="w-full font-bold text-dark" readonly v-model="inputAvanceAcumulado" v-validate="''" name="acumulado" placeholder=""/>
                        <span class="text-sm text-danger" v-show="errors.has('acumulado')">{{ errors.first('acumulado') }}</span>
                    </div>
                </div>
            </div>

            <div class="vx-row">
				<div class="w-full vx-col">
					<div class="flex flex-wrap items-center justify-end mt-2">
						<vs-button @click="aceptar" icon-pack="feather" icon="icon-check" class="mt-2 ml-auto">Aceptar</vs-button>
					</div>
				</div>
			</div>
        </vs-popup>

    </div>
</template>
<script>
import vSelect from 'vue-select';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import VueApexCharts from 'vue-apexcharts';
import FilterViewSidebar from './components/FilterViewSidebar.vue';

const VUE_APP_MAP_ACCESS_TOKEN='pk.eyJ1IjoiY29uc2FjaGFwaSIsImEiOiJjbGh6ZWxscG4wMnVsM3NteHFhYXM0YTBqIn0.d_FvFlICiWjVzsOwR7RJTQ';

export default {
    components: {
        'v-select': vSelect,
        mapboxgl,
        VueApexCharts,
        FilterViewSidebar
    },

    data(){
        return {
            loading                     : false,
            location                    : "",
            access_token                : VUE_APP_MAP_ACCESS_TOKEN,
            center                      : [-71.9634369, -13.5243935],
            map                         : {},

            itemsAll                    : [],
            itemsPerPage                : 10,
            isMounted                   : false,

            popupDetalleProyecto        : false,
            inputCUI                    : null,
            inputNombreInversion        : null,
            inputModalidad              : null,
            inputPimVigente             : null,
            inputAvancePim              : null,
            inputAvanceAcumulado        : null,

            inputSearchCui              : null,
            selectedProvincia           : { value: '', label: 'Todos' },
            selectedDistrito            : null,
            itemsProvincia              : [],
            itemsDistrito               : [],
            itemsUei                    : [],


            nombre_ejecutora: 'Sin registro',
            unidad_ejecutora: '000000',

            filterDataSidebar: false,
        }
    },

    created(){
        this.loadUserInfo();
        this.listarProvincia();
    },

    mounted(){
        this.listarTodoUbicacion();
        this.listarTodoAvance();
        this.isMounted = true;
    },

    computed: {
        currentPage () {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
    },

    watch: {
        selectedProvincia(val){
            if(val.value === '') {
                this.listarTodoUbicacion();
                this.listarTodoAvance();
                this.selectedDistrito = null;
                this.itemsDistrito = [];
            } else {
                this.listarDistrito(val.value);
                this.listarUbicacionPorProvincia(val.value);
                this.listarAvancePorProvincia(val.value);
            }
        },

        selectedDistrito(val){
            console.log(val);
            if(val.value !== "") {
                this.listarUbicacionPorDistrito(val.value);
                this.listarAvancePorDistrito(val.value);
            } else {
                this.listarUbicacionPorProvincia(this.selectedProvincia.value);
                this.listarAvancePorProvincia(this.selectedProvincia.value);
            }
        },
    },

    methods: {
        listarProvincia(){
            this.$vs.loading();
            this.$http.listarProvincia()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsProvincia = response.data;
                    this.itemsProvincia.unshift({value: '', label: 'Todos'})
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarDistrito(id){
            this.$vs.loading();
            this.$http.listarDistritoPorProvincia(id)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsDistrito = response.data;
                    this.itemsDistrito.unshift({value: '', label: 'Todos'})
                     this.selectedDistrito = { value: '', label: 'Todos' };
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarUbicacionPorDistrito(distrito){
            this.$vs.loading();
            this.$http.listarUbicacionPorDistrito(distrito)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.getFeatures(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarAvancePorDistrito(distrito){
            this.$vs.loading();
            this.$http.listarAvancePorDistrito(distrito)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsAll = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarUbicacionPorProvincia(provincia){
            this.$vs.loading();
            this.$http.listarUbicacionPorProvincia(provincia)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.getFeatures(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarAvancePorProvincia(provincia){
            this.$vs.loading();
            this.$http.listarAvancePorProvincia(provincia)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsAll = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarTodoUbicacion(){
            this.$vs.loading();
            this.$http.listarUbicacionesProyecto()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.getFeatures(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarTodoAvance(){
            this.$vs.loading();
            this.$http.listarAvanceProyecto()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsAll = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarTodoUbicacionPorCod(codigo){
            this.$vs.loading();
            this.$http.listarUbicacionesProyectoPorCod(codigo)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.getFeatures(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarTodoAvancePorCod(codigo){
            this.$vs.loading();
            this.$http.listarAvanceProyectoPorCod(codigo)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsAll = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        buscar(){
            if(this.inputSearchCui === "") {
                this.listarTodoUbicacion();
                this.listarTodoAvance();
                return;
            }
            if(this.inputSearchCui !== null || this.inputSearchCui !== "") {
                this.listarTodoUbicacionPorCod(this.inputSearchCui);
                this.listarTodoAvancePorCod(this.inputSearchCui);
                return;
            }
        },

        verDetalle(tr){
            this.$vs.loading();
            this.$http.fetchEstados(tr.cui)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.cargarDatos(response.data);
                    this.popupDetalleProyecto = true;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        cargarDatos(data){
            this.inputCUI                    = data.estado.cui;
            this.inputNombreInversion        = data.estado.nombre;
            this.inputModalidad              = data.estado.modalidad !== null ? data.estado.modalidad.descripcion : null;
            this.inputPimVigente             = this.formatNumber(data.avance.pim);
            this.inputAvancePim              = data.avance.apim;
            this.inputAvanceAcumulado        = data.avance.aacumulado;
        },

        aceptar(){
            this.inputCUI = null;
            this.inputNombreInversion = null;
            this.popupDetalleProyecto = false;
        },

        getFeatures(data){
            let features = [];
            data.forEach(function (item) {
                const ssi =  `https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=${ item.cui }`;
                const desc = `<strong><a href="${ ssi }" target="_blank" title="Ver en SSI">CUI ${ item.cui }</a><br></strong><strong>Nombre de Inversión: </><p>${ item.nombre }</p>`;
                const feature = {
                    'type': 'Feature',
                    'properties': {
                        'description': desc,
                        'icon': 'theatre'
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [item.x, item.y],
                    }
                };
                if(item.x !== null && item.y !== null){
                    features.push(feature);
                }
            });
            this.createMap(features);
        },

        async createMap(values) {
            try {
                mapboxgl.accessToken = this.access_token;
                this.map = new mapboxgl.Map({
                    container: "map",
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: this.center,
                    zoom: 7.6,
                    //projection: 'globe'
                });

                this.map.on('load', async () => {
                    this.map.loadImage(require('@/assets/images/person/icon-marker.png'), (error, image) => {
                        if (error) throw error;
                
                        if (!this.map.hasImage('icon-marker')) {
                            this.map.addImage('icon-marker', image);
                        }

                        this.map.addSource('places', {
                            type: 'geojson',
                            data: {
                                type: 'FeatureCollection',
                                features: values
                            }
                        });

                        this.map.addLayer({
                            id: 'places',
                            type: 'symbol',
                            source: 'places',
                            layout: {
                                'icon-image': 'icon-marker',
                                'icon-size': 0.8,
                                'icon-anchor': 'bottom',
                                'icon-allow-overlap': true
                            }
                        });
                        this.map.on('click', 'places', (e) => {
                            const coordinates = e.features[0].geometry.coordinates.slice();
                            const description = e.features[0].properties.description;
                            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                            }
                            
                            new mapboxgl.Popup()
                            .setLngLat(coordinates)
                            .setHTML(description)
                            .addTo(this.map);
                        });

                        this.map.on('mouseenter', 'places', () => {
                            this.map.getCanvas().style.cursor = 'pointer';
                        });

                        this.map.on('mouseleave', 'places', () => {
                            this.map.getCanvas().style.cursor = '';
                        });
                    });

         
                   
                    
                });

            } catch (err) {
                console.log("map error", err);
            }
        },

        abrirFiltro(){
            this.toggleDataSidebar(true)
        },

        toggleDataSidebar(val = false) {
            this.filterDataSidebar = val;
        },

        filtrar(payload){
            console.log(payload);
        },

        formatNumber(num) {
            if(num === null) return "";
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        },

        accessSsi(tr){
            window.open("https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=" + tr.cui, '_blank').focus();
        },

        loadUserInfo(){
            this.$http.userInfo()
            .then(response => {
                this.nombre_ejecutora = response.data.entidad;
                this.unidad_ejecutora = response.data.unidadejecutora;
            })
            .catch(error => {
                //this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },






        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";

#map {
  height: 75vh;
  width: 100vh;
}

.mapboxgl-popup {
    max-width: 400px;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
}

#data-pip-view {
.vs-con-table {
    @media (max-width: 689px) {
        .vs-table--search {
            margin-left: 0;
            max-width: unset;
            width: 100%;

            .vs-table--search-input {
                width: 100%;
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0.0rem;
        margin-right: 0.0rem;
        > span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search{
            padding-top: 0;

            .vs-table--search-input {
                padding: 1.0rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .vs-table {
        font-size: 0.88rem;
        font-weight: 400;
        tr {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td {
                padding: 10;
            }
            td.td-check {
               padding: 20px !important;
            }
        }
    }

    .vs-table--thead{
        th {
            padding: 10;
            background: #d9d8d8;
      
            &:first-child{
                border-top-left-radius: .3rem;
                border-bottom-left-radius: .3rem;
            }
            &:last-child{
                border-top-right-radius: .3rem;
                border-bottom-right-radius: .3rem;
            }
            .vs-table-text{
                text-transform: uppercase;
                font-weight: 600;
            }
        }
        th.td-check{
            padding: 0 15px !important;
        }
        tr{
            background: none;
            box-shadow: none;
        }
    }

    .vs-table--pagination {
        justify-content: center;
    }
  }
}

.vx-row-actions {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 -1rem;

  & > .vx-col {
    padding: 0 1rem;
  }

  &.match-height>.vx-col {
    display: flex;
  }

  &.no-gutter {
    margin: 0;

    & > .vx-col {
      padding: 0;
    }
  }
}

#modal-detalle-proyecto {
    .vs-popup {
        transition: all .2s;
        z-index: 100;
        width: 740px;
        margin: 10px;
        max-width: calc(100% - 30px);
        max-height: calc(100% - 30px);
        border-radius: 6px;
    }
    .vs-popup--background{
        width: 40000px;
        height: 40000px;
    } 
}

#modal-filtro-proyecto {
    .vs-popup {
        transition: all .2s;
        z-index: 100;
        width: 760px;
        margin: 10px;
        max-width: calc(100% - 30px);
        max-height: calc(100% - 30px);
        border-radius: 6px;
    }
    .vs-popup--background{
        width: 40000px;
        height: 40000px;
    } 
}
</style>